import { Injectable } from '@angular/core';
import { Map } from 'immutable';

import { ColumnModelItemEntity } from '../../domain/column-model-item.entity';
import { ColumnModelListEntity } from '../../domain/column-model-list.entity';

@Injectable()
export class ColumnModelListProvider {
	private readonly columnModelList: ColumnModelListEntity;

	public constructor() {
		this.columnModelList = ColumnModelListEntity.build([
			{
				field: 'label',
				alias: $localize`:i18n=@@subscription.columnModel.list.column.label:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: true,
				visibleIndex: 0,
			},
			{
				field: 'description',
				alias: $localize`:i18n=@@subscription.columnModel.list.column.description:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: false,
				visibleIndex: 1,
			},
			{
				field: 'columns',
				alias: $localize`:i18n=@@subscription.columnModel.list.column.columns:`,
				type: '',
				hasHeaderFilter: false,
				isSearchable: false,
				isFilterable: false,
				visibleIndex: 2,
			},
			{
				field: 'linkedProfileIds',
				alias: $localize`:i18n=@@subscription.columnModel.list.column.profiles:`,
				type: '',
				hasHeaderFilter: false,
				isSearchable: false,
				isFilterable: false,
				visibleIndex: 3,
			},
			{
				field: 'status',
				alias: $localize`:i18n=@@subscription.columnModel.list.column.status:`,
				type: '',
				hasHeaderFilter: false,
				isSearchable: false,
				isFilterable: false,
				visibleIndex: 4,
			},
		]);
	}

	public getList(): ColumnModelListEntity {
		return this.columnModelList;
	}

	public setListElements(
		elements: Map<string, ColumnModelItemEntity>
	): ColumnModelListEntity {
		return this.columnModelList.setElements(elements);
	}
}
